import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'ws-scripts/modules/common';
import { Panel } from 'react-bootstrap';
import { setClassNames } from 'ddc-classnames-js';

const AccordionItem = ({ id, title, content, isActive }) => {
	const labels = useLabels();

	const iconClasses = setClassNames([
		'ddc-icon',
		'icon-style-collapse',
		'd-inline',
		'mr-3',
		'pull-right',
		isActive ? 'ddc-icon-collapse' : 'ddc-icon-expand'
	]);
	const headerClasses = setClassNames(['my-6', 'pl-2']);

	return (
		<Panel eventKey={id} key={id} className="location-panel">
			<Panel.Heading>
				<Panel.Title toggle>
					<h2 className={headerClasses}>
						<span>{labels.get(title)}</span>
						<i
							data-testid="collapsable-icon"
							className={iconClasses}
						/>
					</h2>
				</Panel.Title>
			</Panel.Heading>

			<Panel.Collapse className="bg-transparent">
				<Panel.Body className="p-0">{content}</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

AccordionItem.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	content: PropTypes.node.isRequired,
	isActive: PropTypes.bool.isRequired
};

export default AccordionItem;
